import { useCallback, useEffect } from 'react'
import { compose, hoc, useStore } from '@'
import GetCatalogs from '../../actions/GetCatalogs'
import GetSupplierCoverage from '../../actions/GetSupplierCoverage'
import { $supplierCoverage, $supplierCoverageLoading, $supplierCoverageQuery } from '../../stores'
import { useUrlQuery } from '../CoverageCommon'

const QUERY_FIELDS = ['column']

const loadSupplier = query => GetSupplierCoverage({ page: 1, page_size: 20, ...query })

const container = compose(
    hoc(props => {
        const [supplierCoverage, loading, query] = useStore([
            $supplierCoverage,
            $supplierCoverageLoading,
            $supplierCoverageQuery
        ])

        useUrlQuery($supplierCoverageQuery, QUERY_FIELDS, loadSupplier)

        useEffect(() => {
            GetCatalogs().catch(console.error)
        }, [])

        const handlePage = useCallback((page, pageSize) => {
            GetSupplierCoverage({ ...$supplierCoverageQuery.getState(), page, page_size: pageSize })
        }, [])

        return {
            supplierCoverage,
            loading,
            query,
            handlePage,
            ...props
        }
    })
)

export default container
